import React from "react";
import { Dealer } from "hooks/useDealers";
import { SkeletonTableRows } from "components/shared/SkeletonTableRows";
import {
  DealersContainer,
  ActionButton,
  DealerRow,
  DealerCell,
  ActionCell,
  TableHeader,
  StatusBadge,
  ResponsiveTableWrapper,
} from "styles/components/dealersList.styles";

interface DealersTableViewProps {
  dealers: Dealer[];
  isLoading: boolean;
  onRowClick: (dealer: Dealer) => void;
  onEnableDealer: (dealer: Dealer) => void;
  onDisableDealer: (dealer: Dealer) => void;
}

const DealersTableView: React.FC<DealersTableViewProps> = ({
  dealers,
  isLoading,
  onRowClick,
  onEnableDealer,
  onDisableDealer,
}) => {
  return (
    <ResponsiveTableWrapper>
      <DealersContainer>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <TableHeader>Name</TableHeader>
              <TableHeader>Dealer Name</TableHeader>
              <TableHeader>Email</TableHeader>
              <TableHeader>Country</TableHeader>
              <TableHeader>Status</TableHeader>
              <TableHeader style={{ textAlign: "right" }}>Actions</TableHeader>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <SkeletonTableRows rows={5} columns={6} />
            ) : (
              dealers.map((dealer: Dealer) => (
                <DealerRow key={dealer.id} onClick={() => onRowClick(dealer)}>
                  <DealerCell>
                    {dealer.firstName} {dealer.lastName}
                  </DealerCell>
                  <DealerCell>{dealer.dealerName || "N/A"}</DealerCell>
                  <DealerCell>{dealer.email}</DealerCell>
                  <DealerCell>{dealer.country || "N/A"}</DealerCell>
                  <DealerCell>
                    <StatusBadge
                      status={dealer.disabled ? "disabled" : "active"}
                    >
                      {dealer.disabled ? "Disabled" : "Active"}
                    </StatusBadge>
                  </DealerCell>
                  <ActionCell onClick={(e) => e.stopPropagation()}>
                    {dealer.disabled ? (
                      <ActionButton
                        className="enable"
                        onClick={() => onEnableDealer(dealer)}
                      >
                        <i className="pi pi-check-circle" /> Enable
                      </ActionButton>
                    ) : (
                      <ActionButton
                        className="disable"
                        onClick={() => onDisableDealer(dealer)}
                      >
                        <i className="pi pi-ban" /> Disable
                      </ActionButton>
                    )}
                  </ActionCell>
                </DealerRow>
              ))
            )}
          </tbody>
        </table>
      </DealersContainer>
    </ResponsiveTableWrapper>
  );
};

export default DealersTableView;
